/** * * Asynchronously loads the component for
UpdateProfile
* */ import { lazyLoad } from "utils/loadable";
export const UpdateProfile = lazyLoad(
  () => import("./index"),
  (module) => module.UpdateProfile
);
